import React from 'react';
import { Statistic } from 'antd';
import type { StatisticProps as AntStatisticProps } from 'antd';
import type { BaseComponentProps } from '../../types/common';

export interface AndStatisticsProps extends AntStatisticProps, BaseComponentProps {}

export const AndStatistics: React.FC<AndStatisticsProps> = ({
  id, sessionId, develop, ...restProps
}) => {
  return <Statistic {...restProps} />;
};

export default AndStatistics;
